angular.module('mtic')
.service('TeacherDataService', function (
  $log,
  $http,
  $q,
  api,
  userAccount,
  Firebase,
  EventManager,
  DataCacheService,
  DataPathService,
  language,
  LogReducer,
  TeacherClassStatsService,
  DATA_HOST,
  StudentDataService
) {

  // vars
  var eventManager = new EventManager('TeacherDataService');

  // private methods
  /**
   * Capitalize the first letter in a string
   * @param  {String} string
   * @return {String}
   */
  var capitalizeFirstLetter = function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
  }
  var getModuleMap = function(class_id, next){
    return DataCacheService.fetch({
      action: next,
      key: DataPathService['class/modulesMapContainer'](class_id),
      fetcher: function(cb){
        return api.getClassModuleMaps(class_id)
        .then(function(moduleMapsContainer){
          cb(moduleMapsContainer);
        })
      },
    });
  }
  var getModuleContainerMap = function(class_id, next){
    return DataCacheService.fetch({
      action: next,
      key: DataPathService.dynamic('class/moduleContainer/:classId',{classId:class_id}),
      fetcher: function(cb){
        return getModuleMap(class_id).then(function(moduleMapsContainers) {
          cb(moduleMapsContainers.Modules[0])
        })
      },
    });
  }
  var getModuleListFlat = function(class_id, next){
    return DataCacheService.fetch({
      action: next,
      key: DataPathService['class/modulesListFlat'](class_id),
      fetcher: function(cb){
        return getModulesAndSubModules(class_id, function(allModules){
          var modulesListFlat = _.map(allModules, function(moduleResource){
            return {
              name: moduleResource.name,
              slug: moduleResource.slug,
              content: moduleResource.content,
              resource_id: moduleResource.id,
              hasSubModules: moduleResource.hasSubModules,
              display: moduleResource.display,
              config: moduleResource.config
            }
          })
          cb(modulesListFlat);
        })
      },
    });
  }

  var getModuleResourceListFlatMap = function(class_id, cb){
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/modulesListFlatMap'](class_id),
      fetcher: function(next){
        return getModuleMap(class_id).then(function(modules){
          var modulesListFlatMap = {};
          var addNewResource = function(resource, module){
            if(resource.resource_type !== 'symlink') {
              modulesListFlatMap[resource.id] = _.extend({
                module_id: module.module_id
              }, resource);
            }
            if(resource.children && resource.children.length > 0) {
              resource.children.map(function(child){
                addNewResource(child, module)
              })
            }
          }
          _.each(modules.Modules, function(module){
            _.each(module.Resource.children, function(resource){
              addNewResource(resource, module)
            })
          })
          next(modulesListFlatMap)
        })
      },
    });
  }

  var getStudentWorkForModuleByTeacher = function (moduleResource, user_id, class_id, cb, flush) {
    if (flush){
      DataCacheService.flush( DataPathService['class/module/student/work'](class_id, moduleResource.module_id, user_id));
    }
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/module/student/work'](class_id, moduleResource.module_id, user_id),
      fetcher: function(cb){
        return api.getStudentModuleResourceStateByTeacher(moduleResource.module_id, user_id, class_id).
        then(function (studentWorks) {
          cb(StudentDataService.genModuleWIthWork(studentWorks, moduleResource, user_id));
        });
      },
    });
  }

  var getStudentWorkSummaryForModuleByTeacher = function (moduleResource, user_id, class_id, cb) {
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/module/student/workSummary'](class_id, moduleResource.module_id, user_id),
      fetcher: function(cb){
        getStudentWorkForModuleByTeacher(moduleResource, user_id, class_id, function(detail){
          var summary = {};
          _.each(detail.resources, function(resource){
            var resourceTypeSummary = summary[resource.resource_type];
            if (!resourceTypeSummary){
              resourceTypeSummary = summary[resource.resource_type] = {atLeastOne: false, allLocked: true, noIncomplete: true, total:0, num:0};
            }
            if (!resource.locked){
              resourceTypeSummary.allLocked = false;
            }
            if (!resource.complete){
              resourceTypeSummary.noIncomplete = false;
            }
          });
          cb({
            module_id: moduleResource.module_id,
            summary: summary
          });
        })
      }
    });
  }

  var getStudentsAppEvents = function(class_id, module_id, options, cb) {
    var from = options.from || moment().subtract(7,'days').format('YYYY-MM-DD');
    var to = options.to || moment().format('YYYY-MM-DD');
    var limit = options.limit || 200;
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/module/work'](class_id, module_id, from, to, limit),
      fetcher: function(cb){
        return api.getStudentsAppEvents(class_id, module_id, from, to, limit)
        .then(function(modulesContainer){
          cb(modulesContainer);
        })
      },
    });
  }

  var getStudentAppEventsSummarized = function(class_id, cb){
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/workSummarized'](class_id),
      fetcher: function(cb){ cb([]); },
    });
  }

  var getUserIDSync = function(){
    return userAccount.getData().user_id;
  }

  var getStudentWorkForClass = function(student_user_id, class_id, cb, flush) {
    if (flush){
      DataCacheService.flush( DataPathService['class/student/work'](class_id, student_user_id) );
    }
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/student/work'](class_id, student_user_id),
      fetcher: function(cb){
        getModuleMap(class_id, function(moduleMapsContainer){
          var classStudentWork = {
            modules: {}
          }
          _.each(moduleMapsContainer.Modules, function(moduleContainer){
            getStudentWorkSummaryForModuleByTeacher(moduleContainer, student_user_id, class_id, function(data){
              classStudentWork.modules[moduleContainer.module_id] = data;
              cb(classStudentWork); // sending same object multiple times on purpose (to force scope refresh)
            })
          });
        });
      }
    });
  }

  /**
  * Get the work that a teacher did (as a student) in a module
  * @param  {Integer}   class_id
  * @param  {Bool}   flush
  * @param  {Function} cb
  * @return {Function}
  */
  var getStudentWorkForModuleOfTeacher = function(class_id, flush, cb){
    var teacher_user_id = getUserIDSync();
    if (flush){
      DataCacheService.flush( DataPathService['class/teacher/work'](class_id, teacher_user_id) );
    }
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/teacher/work'](class_id, teacher_user_id),
      fetcher: function(cb){
        return getModuleMap(class_id , function(moduleDatas){
          var moduleData = moduleDatas.Modules[0];
          cb(StudentDataService.genModuleWIthWork([], moduleData, teacher_user_id));
          //getStudentWorkForModuleByTeacher(moduleData, teacher_user_id, class_id, cb, flush)
        })
      }
    });
  }

  var getArchivedStudents = function(class_id){
    return api.getArchivedStudents(class_id,'mtic_teacher');
  }

  var getClassStats = function(class_id, reset, cb,isArchived){
    return DataCacheService.fetch({
      action: cb,
      reset: reset,
      key: DataPathService.dynamic('/class/:classId/work', {classId: class_id}),
      fetcher: function(next){
        return $q.all([
          getModulesAndSubModules(class_id),
          api.getClassResourceStates(class_id,isArchived, true),
          getClassStudentMap(class_id, null, reset || false, isArchived),
        ]).then(function(datas){
            var moduleData = angular.copy(datas[0])
            var userRoles = datas[1];
            //this part is added because some g78 m1/m3 lessons were marked as incomplete
            userRoles.forEach( function(user){
              user.User.ClassWorks.forEach(function(work){
                if((work.WorkBatch.Resource.parent_resource_id === 69 || work.WorkBatch.Resource.parent_resource_id === 373) && work.WorkBatch.Resource.resource_type !== "assessment" && work.WorkBatch.StudentResourceState){
                  work.WorkBatch.StudentResourceState.completions = 1;
                  work.WorkBatch.StudentResourceState.complete = true;
                  work.WorkBatch.StudentResourceState.score_max = 1;
                }
              })
            })
            var studentMap = datas[2]
            TeacherClassStatsService.computeStats(moduleData, userRoles, studentMap).then(function(stats){
              $log.debug('[[TeacherDataService]]',moduleData, userRoles, stats)
              next(stats)
            })
          })
      }
    })
  }

  var getArchivedClassStats = function(class_id,reset,cb,isArchived){
    var defer = $q.defer();
    $q.all([
      getModulesAndSubModules(class_id),
      api.getClassResourceStates(class_id,isArchived, true),
      getClassStudentMap(class_id, null, reset, isArchived),
    ]).then(function(datas){
        var moduleData = angular.copy(datas[0])
        var userRoles = datas[1]
        var studentMap = datas[2]
        TeacherClassStatsService.computeStats(moduleData, userRoles, studentMap).then(function(stats){
          // $log.debug('[[TeacherDataService]]',moduleData, userRoles, stats)
          defer.resolve(stats)
        })
      });

      return defer.promise;
  }



  var getModulesAndSubModules = function(class_id, cb){
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService.dynamic('/class/:classId/allModules', {classId: class_id}),
      fetcher: function(next){
        return getModuleMap(class_id).then(function(classMetaModules){
          var allModules = {};
          var seekAndRetrieveSubModules = function(someModule){
            var copy = angular.copy(someModule).children || []
            var foundSubs =  copy.filter(function(resource){
              if(['sub_module', 'resource_module'].indexOf(resource.resource_type) > -1){
                allModules[resource.id] = resource
                resource.hasSubModules = seekAndRetrieveSubModules(resource)
                return true;
              }
              else{
                return false;
              }
            })
            return foundSubs.length > 0;
          }
          classMetaModules.Modules.forEach(function(moduleData){
            var moduleResource = moduleData.Resource;
            moduleResource.hasSubModules = seekAndRetrieveSubModules(moduleResource)
            allModules[moduleResource.id] = moduleResource
          })
          next(allModules);
        })
      }
    })
  }

  var getClassPanelConfig = function(class_id, cb){
     return DataCacheService.fetch({
      action: cb,
      key: DataPathService.dynamic('/class/:classId/modules/config', {classId: class_id}),
      fetcher: function(next){
        return getModulesAndSubModules(class_id).then(function(allModules){
          var panels = {};
          _.map(allModules,function(module){
            if(module.config.teacher_panel) {
              panels = angular.extend(panels, module.config.teacher_panel)
              panels = angular.extend(panels, module.config.teacher_panel_archive)
            }
          })
          next(_.map(panels, function(panel, panelId){
            return {
              id: panelId,
              name: capitalizeFirstLetter(panelId)
            }
          }))
        })
      }
    })
  }


 var getClassStudents = function(class_id, cb, reset,isArchived){
    return DataCacheService.fetch({
      action: cb,
      reset: reset,
      key: DataPathService['class/students']( class_id ),
      fetcher: function(cb){
        api.getClassMembers(class_id,'mtic_teacher',isArchived)
        .then(function(students){
          students = _.sortBy(students, function(student){
            student.display_name = [student.info.first_name, student.info.last_name].join(' ');
            //if they have more than 1 it will show the first
            if (student.auths[0]){
              student.user_name = student.auths[0].uuid;
            }
            else{
              student.user_name = '---';
            }
            return String(student.info.last_name + student.info.first_name).toUpperCase() ;
          })
          cb(students);
        })
      },
    });
  }

  var getClassStudentMap = function(class_id, cb, reset, isArchived){
    //var isArchivedVal = isArchived || false;
    return DataCacheService.fetch({
      action: cb,
      reset: reset,
      key: DataPathService['class/studentsMap']( class_id ),
      fetcher: function(cb){
        return getClassStudents(class_id, function(students){
          var studentMap = {};
          _.each(students, function(student){
            studentMap[student.user_id] = student;
          })
          cb(studentMap);
        }, reset,isArchived)
      },
    });
  }
  var getUserGroups = function(reset, action) {
    var key = DataPathService.dynamic('user/:userId/groups', {userId: getUserIDSync() });
    if(reset){
      DataCacheService.flush(key)
    }
    return DataCacheService.fetch({
      action: action,
      key: key,
      fetcher: function(next){
        return api.getUserGroups().then(next)
      }
    })
  }


  var getCustomResource = function(classId, resourceId, reset) {
    return DataCacheService.fetch({
      reset: reset,
      key: DataPathService.dynamic('class/:classId/custom_module/resource/:resourceId', {classId:classId, resourceId: resourceId }),
      fetcher: function(next){
        return api.getCustomResource(classId, resourceId).then(function(groupData){
          next(groupData[0])//.CustomModule.Resource.children[0])
        })
      }
    })
  }
  var getCustomResources = function(classId, resourceIds, reset) {
    return $q.all(resourceIds.map(function(resourceId){
      return getCustomResource(classId, resourceId, reset)
    }))
  }

  var getSchoolModules = function({school_id, reset}) {
    return DataCacheService.fetch({
      reset,
      key: DataPathService.dynamic('school/:school_id/modules', {school_id}),
      fetcher(next) {
        return api.getSchoolModules(school_id).then((groupModules) => {
          next(
            groupModules.map( groupModule => {
              // console.log('groupModule.Module.Resource.slug', groupModule.Module.Resource.slug)
              return {
                getName() {
                  return language.get(groupModule.Module.Resource.slug)
                },
                module_id: groupModule.Module.id,
                module_resource_id: groupModule.Module.Resource.id,
              }
            })
          )
        });
      }
    })
  }
  // init

  // public methods
  return {
    getSchoolModules: getSchoolModules,
    getModuleContainerMap:getModuleContainerMap,
    getCustomResources: getCustomResources,
    getClassStudentMap: getClassStudentMap,
    getModuleResourceListFlatMap: getModuleResourceListFlatMap,
    getClassPanelConfig: getClassPanelConfig,
    currentActiveMeta: null,
    searchStudent({uuid, noschool=false, auth_type='microsoftStrategy'}) {
      return DataCacheService.fetch({
        key: DataPathService.dynamic('searchStudent/:noschool/:auth_type/:uuid', {noschool, uuid, auth_type}),
        fetcher(next) {
          return api.findStudentNoSchool({uuid, auth_type}).then( students => {
            return next(
              students.map( ({user_id, info, auths, moduleResource, classroom}) =>
                ({
                  user_id,
                  first_name: info.first_name,
                  last_name: info.last_name,
                  full_name: [info.first_name,info.last_name].join(' '),
                  email: info.email,
                  classroom,
                  user_name: auths.filter( auth => auth.auth_type === auth_type )[0].uuid,
                  moduleResource,
                  getModuleName() {
                    return language.get(moduleResource.slug)
                  }
                })
              )
            );
          } );
        }
      })
    },
    transferStudent({user_id, to_class_id, from_class_id, transferProgress}) {
      return api.transferStudent(user_id, to_class_id, transferProgress ? from_class_id : undefined )
    },
    getAppLogs: function(class_id, options, next){
      var from = options.from || moment().subtract(7,'days').format('YYYY-MM-DD');
      var to = options.to || moment().format('YYYY-MM-DD');
      var limit = options.limit || 200;
      return DataCacheService.fetch({
        action: next,
        key: DataPathService['class/users/app/events'](class_id, from, to, limit),
        fetcher: function(cb){
          return getModuleMap(class_id, function(modules){
            _.each(modules.Modules, function(module){
              return $q.all([
                getStudentsAppEvents(class_id, module.module_id, {from: from, to:to, limit:limit}),
                getClassStudentMap(class_id),
                getModuleResourceListFlatMap(class_id)
              ]).then(function(datas){
                var group = datas[0][0]//always returns an array of 1
                var userMapping = datas[1]
                var moduleResourceMapping = datas[2]
                return cb(new LogReducer(
                  group.Group.UserRoles,
                  userMapping,
                  moduleResourceMapping
                ));
              })
            })
          });
        }
      });
    },
    getStudentWorkForModuleOfTeacher: function(class_id, flush, cb){
         return getStudentWorkForModuleOfTeacher(class_id, flush, cb)
   },
    createClass: function(schoolId, className, classDescription, cb){
      throw new Error("TeacherDataService.createClass is no longer supported!")
      // return api.createClass(schoolId, className, classDescription).
      // then(function(newClass) {
      //   cb(newClass);
      // });
    },
    createSchoolClass({module_id,school_id,name,description}) {
      return api.createSchoolClass({module_id,school_id,name,description})
    },
    getModuleMap: function(class_id, cb){
      return getModuleMap(class_id, cb)
    },

    getModuleListFlat: function(class_id, cb){
      return getModuleListFlat(class_id, cb);
    },

    getUserId: function(cb){
      return cb( getUserIDSync() );
    },

    getUserClasses: function(reset, cb){
      var TeacherDataService = this;
      var key = DataPathService['user/classes']( getUserIDSync() );
      if(reset){
        DataCacheService.flush(key)
      }
      return DataCacheService.fetch({
        action: cb,
        key: key,
        fetcher: function(cb){
          return getUserGroups(reset).then(function(groupRoles){
            var classes = groupRoles.filter(function(groupRole){
              return groupRole.role_type === 'mtic_teacher' && groupRole.Group.group_type === 'mtic_class'
            }).map(function(groupRole) {
              return groupRole.Group;
            });
            _.each(classes, function(classroom){
              classroom.code = TeacherDataService.renderClassCodeStr(classroom)
            })
            return classes;
          }).then((classes) => {
            const allPromise = [];
            _.each(classes, function(classroom) {
              allPromise.push(TeacherDataService.getCountry(classroom.id).then((country) => {
                classroom.country = country;
              }));
            });
            Promise.all(allPromise).then(() => {
              cb(classes);
            });
          })
        },
      });
    },

    renderClassCodeStr: function(classroom){
      return getUserIDSync() +'c'+ classroom.id;
    },

    getSchoolClasses: function(reset, school_id, get_archived){
      var TeacherDataService = this;
      var key = DataPathService.dynamic('school/:school_id/classes', {school_id});
      if(reset){
        DataCacheService.flush(key)
      }
      return DataCacheService.fetch({
        key: key,
        reset,
        fetcher: function(next){
          return api.getClassesForSchool(school_id).then( classes => {
            if(get_archived){
              classes = classes.filter( function(cur_class){
                return cur_class.GroupModules[0].archived
              })
            }else{
              classes = classes.filter( function(cur_class){
                return !cur_class.GroupModules[0].archived
              })
            }

            next(
              classes.map( classroom => {
                if(classroom.GroupModules.length !== 1) {
                  throw new Error(`Too many groupModules for ${classroom.id}`)
                }
                var groupModule = classroom.GroupModules[0];
                if(!groupModule.Module) {
                  throw new Error(`No Module for ${classroom.id}`)
                }
                var module = groupModule.Module;
                if(!module.Resource) {
                  throw new Error(`No Resource for ${module.id}`)
                }
                var moduleResource = module.Resource;
                return {
                  id: classroom.id,
                  name: classroom.name,
                  description: classroom.description,
                  module_id: module.id,
                  module_resource_id: moduleResource.id,
                  shared_users: classroom.UserRoles && classroom.UserRoles.length > 0 && classroom.UserRoles[0].Group ? classroom.UserRoles[0].Group.UserRoles : [],
                  getType() {
                    return language.get(moduleResource.slug);
                  },
                  code: TeacherDataService.renderClassCodeStr(classroom)
                }
              })
             )
          })
        },
      });
    },
    getSchoolArchivedClasses: function(reset, school_id){
      var TeacherDataService = this;
      var defer = $q.defer();
      api.getClassesForSchool(school_id).then( classes => {
        classes = classes.filter( function(cur_class){
          return cur_class.GroupModules[0].archived
        });
        var archivedClasses = [];
        classes.forEach( function(classroom) {
          if(classroom.GroupModules.length !== 1) {
            throw new Error(`Too many groupModules for ${classroom.id}`)
          }
          var groupModule = classroom.GroupModules[0];
          if(!groupModule.Module) {
            throw new Error(`No Module for ${classroom.id}`)
          }
          var module = groupModule.Module;
          if(!module.Resource) {
            throw new Error(`No Resource for ${module.id}`)
          }
          var moduleResource = module.Resource;
          var modifiedClass = {
            id: classroom.id,
            name: classroom.name,
            description: classroom.description,
            module_id: module.id,
            module_resource_id: moduleResource.id,
            getType() {
              return language.get(moduleResource.slug);
            },
            code: TeacherDataService.renderClassCodeStr(classroom)
          }
          // $log.log(modifiedClass);
          archivedClasses.push(modifiedClass);
        });

        defer.resolve(archivedClasses);
      });

      return defer.promise;
    },
    getUserSchools: function(cb, reset){
      return DataCacheService.fetch({
        action: cb,
        reset,
        key: DataPathService['user/schools']( getUserIDSync() ),
        fetcher: function(cb){
          var schools = userAccount.getData().roles.filter(function(role) {
            return role.group.group_type === 'school' || role.group.group_type === 'no_school';
          }).map(function(role) {
            return role.group
          })
          cb(schools);
        },
      });
    },

    getClassStudents: function(class_id, cb, reset){
      return getClassStudents(class_id, cb, reset)
    },

    getClassAgendas: function(classId, flush, cb){
      return DataCacheService.fetch({
        action: cb,
        key: DataPathService.dynamic('class/:classId/agendas', {classId: classId}),
        reset: flush,
        fetcher: function(next){
          return $q.all([
            getClassStudentMap(classId),
            getModuleResourceListFlatMap(classId),
            api.getClassAgenda(classId)
          ]).then(function(datas){
            var studentMap = datas[0]
            var resourceMap = datas[1]
            return $q.all(datas[2].Agendas.map(function(agenda){
              if(!agenda.is_for_all_class){
                agenda.studentRefs = agenda.students.map(function(user_id){
                  return studentMap[user_id];
                })
              }
              var custom_resources = {};
              return $q.all(agenda.resources.map(function(resource_id){
                if(resourceMap[resource_id]) {
                  return $q.resolve(resourceMap[resource_id])
                }else{
                  return getCustomResource(classId, resource_id, true).then(function(cResource){
                    if(cResource){
                      custom_resources[cResource.id] = cResource;
                    }
                    return cResource;
                  })
                }
              })).then(function(resourceRefs){
                agenda.resourceRefs = resourceRefs;
                agenda.custom_resources = custom_resources;
                agenda.StudentAgendaItems = agenda.StudentAgendaItems.filter(function(studentAgendaItem){
                  studentAgendaItem.user = studentMap[studentAgendaItem.user_id]
                  studentAgendaItem.resource = resourceMap[studentAgendaItem.resource_id]
                  if(!studentAgendaItem.resource) {
                    if(custom_resources[studentAgendaItem.resource_id]){
                      studentAgendaItem.resource = custom_resources[studentAgendaItem.resource_id];
                    }
                  }
                  return !!studentAgendaItem.resource;
                })
                return agenda;
              });
            })).then(function(agendas){
              next(agendas.sort(function(agendaA, agendaB){
                return moment(agendaB.open_date).diff(agendaA.open_date);
              }))
            })
          })
        },
      });
    },

    createAgenda: function(class_id, resource_ids, description, date_close, date_open, custom_resources, user_ids, sub_module_resource_id, lockOptions, hideFromStudents, competition_ids){
      if(!lockOptions) {lockOptions = {}}
      // $log.log('from create agenda : ' , hideFromStudents)
      var agenda_definition = {
        "description": description,
        "date_close": moment(date_close).hour(23).minute(59).second(59).toDate(),
        "date_open": moment(date_open).toDate(),
        "force_unlock": lockOptions.force_unlock || null,
        "force_redo": lockOptions.force_redo ||false,
        "custom_resources": custom_resources,
        "published": !hideFromStudents,
        "competition_ids": competition_ids || null
      }
      if(lockOptions.attempt_limit) {
        agenda_definition.attempt_limit = lockOptions.attempt_limit;
      }
      return api.createAgenda(class_id, sub_module_resource_id, resource_ids, user_ids, agenda_definition)
    },

    updateClassName: function(classId, name){
      return api.updateClass(classId, {
        name: name
      })
    },

    updateClassInfo: function(classId, name, description){
      return api.updateClass(classId, {
        name,
        description
      })
    },

    togglePublishAgenda: function(classId, agenda_id, publishStatus) {
      return api.updateAgendaProperty(classId, agenda_id, [{
        property_name: 'published',
        property_value: publishStatus
      }])
    },

    updateAgenda: function(classId, agenda_id, updates) {
      var apiUpdate = [];
      if('description'  in updates) {
        apiUpdate.push({
          property_name: 'description',
          property_value: updates.description
        })
      }
      if('date_close'  in updates) {
        apiUpdate.push({
          property_name: 'date_close',
          property_value: updates.date_close
        })
      }
      if('date_open'  in updates) {
        apiUpdate.push({
          property_name: 'date_open',
          property_value: updates.date_open
        })
      }
      if('resources'  in updates) {
        apiUpdate.push({
          property_name: 'resources',
          property_value: updates.resources
        })
      }
      if('students'  in updates) {
        apiUpdate.push({
          property_name: 'students',
          property_value: updates.students
        })
      }
      if('custom_resources'  in updates) {
        apiUpdate.push({
          property_name: 'custom_resources',
          property_value: updates.custom_resources
        })
      }
      if('force_unlock'  in updates) {
        apiUpdate.push({
          property_name: 'force_unlock',
          property_value: updates.force_unlock
        })
      }
      if('force_redo'  in updates) {
        apiUpdate.push({
          property_name: 'force_redo',
          property_value: updates.force_redo
        })
      }
      if('published' in updates){
        apiUpdate.push({
          property_name: 'published',
          property_value: updates.published
        });
      }
      if('archived' in updates){
        apiUpdate.push({
          property_name: 'archived',
          property_value: updates.archived
        });
      }
      return api.updateAgendaProperty(classId, agenda_id, apiUpdate);
    },

    deleteAgenda: function(classId, agenda_id){
      return api.deleteAgendaProperty(classId, [agenda_id])
    },

    getStudentWorkForClass: function(student_user_id, class_id, cb, flush) {
      return getStudentWorkForClass(student_user_id, class_id, cb, flush);
    },

    getClassStats: getClassStats,

    getArchivedClassStats: getArchivedClassStats,

    getArchivedStudents:getArchivedStudents,

    getStudentsAppEvents: getStudentsAppEvents,

    /**
     * Returns a list of modules that have only leafs
     * @param  {Integer}   classId
     * @param  {Function} cb
     * @return {Promise}
     */
    getClassFullModules: function(classId, cb){
      return DataCacheService.fetch({
        action: cb,
        key: DataPathService.dynamic('class/:classId/fullmodules', {classId: classId}),
        fetcher: function(next){
          return getModulesAndSubModules(classId).then(function(moduleAndSubs){
            next(_.toArray(moduleAndSubs).filter(function(module){return !module.hasSubModules}))
          })
        }
      })
    },
    getClassFullModulesStructured: function(classId, cb){
      return DataCacheService.fetch({
        action: cb,
        key: DataPathService.dynamic('class/:classId/fullmodulesstruct', {classId: classId}),
        fetcher: function(next){
          return getModulesAndSubModules(classId).then(function(moduleAndSubs){
            var struct_arr = _.toArray(moduleAndSubs).filter(function(module){return (!module.hasSubModules)|| module.id === 192});
            var cycle_data = _.toArray(moduleAndSubs).filter(function(module){return module.hasSubModules && module.id !== 192})[0];
            var struct = {resources: struct_arr, meta_config: cycle_data.config, resource_slug: cycle_data.slug};
            next(struct)
          })
        }
      })
    },
    getC3ClassStudents_customForUser: function(cb){
      return DataCacheService.fetch({
        action: cb,
        key: DataPathService['user/students_c3custom']( getUserIDSync() ),
        fetcher: function(cb){
          var user_id = userAccount.getData().user_id
          var url  = DATA_HOST.C3_TEACHER_CONFIGS.path+user_id+DATA_HOST.C3_TEACHER_CONFIGS.ext;
          return $http.get(url)
          .then(
            function success(res){
              // $log.debug('DATA_HOST.C3_TEACHER_CONFIGS', url, res.data);
              var classListWithPasswords = res.data;
              _.sortBy(classListWithPasswords, 'student_username');
              cb(classListWithPasswords);
            }
          );
        },
      });
    },
    getClassStudentPasswords: function(classId){
      return DataCacheService.fetch({
        key: DataPathService.dynamic('class/:classId/students/passwords',{classId: classId}),
        fetcher: function(next){
          return Firebase.database().ref('/classAccounts/' + classId).once('value').then(function(snap){
            next(snap.val())
          })
        }
      })
    },
    getCompetitionLeaderBoard: function(comp_id){
      return api.getCompetitionLeaderBoard(comp_id);
    },
    getLeaderBoardTopPerformer: function(agenda_id){
      return api.getLeaderBoardTopPerformer(agenda_id);
    },
    getStudentAssessmentPdf: function(student_id, resource_id, group_id){
      return api.getStudentAssessmentPdf(student_id, resource_id, group_id);
    },
    getClassAssessmentData: function(resource_id, group_id, date_open, date_close){
      return api.getClassAssessmentData(resource_id, group_id, date_open, date_close);
    },    
    getPdfAvailability: function(user_id, group_id){
      return api.getPdfAvailability(user_id, group_id);
    },
    importAgenda: function(class_id, import_code){
      return api.importAgenda(class_id, import_code);
    },
    /**
     * Gets the country of the class.
     * Please refer to groups.groupType == 'country' in the db for what country names its expecting
     * If updating this, please update the `getCountry` in mtic2\src\main\services\StudentDataService.js as well :/
     * @param {number} class_id
     * @returns {(string|null)}
     */
    getCountry: function(class_id) {
      return DataCacheService.fetch({
        key: DataPathService.dynamic('class/country/:classId', { classId: class_id }),
        fetcher: function(next) {
          return api.getCountryOfClass(class_id).then(function(data) {
            if (data) {
              next(data.name)
            } else {
              next(null);
            }
          });
        }
      });
    },
  }
//
});
